import React from 'react';

import { Navbar, Nav, NavItem } from 'reactstrap';



const Footer = () => {
  return (
    <Navbar>
      <Nav navbar>
        <NavItem>
   
        </NavItem>
      </Nav>
    </Navbar>
  );
};

export default Footer;
